export default __webpack_public_path__ + "static/avantages-geovelo-e969cacf087f948970d727cdbc467609.jpeg";